import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {DashboardData} from "./dashboard.data";

@Injectable()
export class DashboardEntityModel extends EntityModel<DashboardData> {
    constructor(injector: Injector) {
        super(injector, DashboardData);
    }

    override getResourceName(): string {
        return "bi-dashboard";
    }
}
